import { useEffect, useMemo, useState } from 'react';
import { Card, CardContent } from '@web/components/ui/card';
import { trpc } from '@web/lib/trpc';
import PaymentTable from './PaymentTable';
import { Button } from '@web/components/ui/button';
import { Spinner } from '@web/components/ui/spinner';

export default function Payments({ contactId }: { contactId: string }) {
  const [paginationLimit, setPaginationLimit] = useState(10);
  const [showButton, setShowButton] = useState(true);

  const {
    data: paymentsData,
    isFetching,
    fetchNextPage,
  } = trpc.payment.listAllWithLimit.useInfiniteQuery(
    {
      limit: paginationLimit,
      contactId: contactId,
    },
    {
      getNextPageParam: (lastPage) => ({
        paymentId: lastPage.at(-1)?.paymentId ?? '',
      }),
    },
  );

  const allPayments = useMemo(
    () => paymentsData?.pages.flatMap((page) => page) ?? [],
    [paymentsData],
  );

  useEffect(() => {
    if (allPayments.length < paginationLimit) {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
  }, [allPayments.length, paginationLimit, paymentsData]);

  const LoadMoreHandler = async () => {
    setPaginationLimit((limit) => limit + 10);
    await fetchNextPage();
  };

  return (
    <Card className="overflow-hidden rounded-xl border-2 shadow-2xl">
      <CardContent className="p-2">
        <PaymentTable payments={allPayments} />

        {!allPayments.length && (
          <Card className="mt-2 border-2">
            <CardContent className="p-2 text-center">
              <p className="font-bold text-gray-800 dark:text-gray-200">
                No payments yet.
              </p>
            </CardContent>
          </Card>
        )}
      </CardContent>

      {showButton && (
        <div className="flex w-full justify-end p-6">
          <Button
            className="rounded p-4"
            onClick={() => {
              void LoadMoreHandler();
            }}
          >
            {isFetching ? <Spinner /> : 'Load More'}
          </Button>
        </div>
      )}
    </Card>
  );
}
